// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1xp_F","newExpiryDate":"styles_newExpiryDate__3IfjW","footer":"styles_footer__1oE3U"};